module.exports = __webpack_public_path__ + "img/802f0c9817cec7c1c4368f911fe35e99.png";